import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1efe0031&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1efe0031&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efe0031",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1efe0031')) {
      api.createRecord('1efe0031', component.options)
    } else {
      api.reload('1efe0031', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1efe0031&scoped=true", function () {
      api.rerender('1efe0031', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/dashboard/index.vue"
export default component.exports